import {
  AUTH_ADMIN_ACL,
  AUTH_ADMIN_INFO,
} from '@/store/action_types/auth';
import { GET_DASHBOARDS } from '@/store/action_types/dashboards';
import { I18N_SET_LANG } from '@/store/action_types/i18n';
import {
  MISC_FETCH_BRANDS,
  MISC_INIT_DATA,
} from '@/store/action_types/misc';
import { noop } from 'lodash-es';
import { useTypedStore } from '@/store';
import type { AvaliableLocales } from '@/i18n';

let current: Promise<void> | null = null;

const loadCritical = async () => {
  const store = useTypedStore();

  await store.dispatch(`auth/${AUTH_ADMIN_ACL}`);
  await store.dispatch(`auth/${AUTH_ADMIN_INFO}`);
  await store.dispatch(
    `i18n/${I18N_SET_LANG}`,
    store.getters['auth/adminInfo'].language_code as AvaliableLocales,
  );
  await store.dispatch('reports/getSettings');
  await Promise.all([
    store.dispatch('session/initialSessionData'),
    store.dispatch(`dashboards/${GET_DASHBOARDS}`).catch(noop),
    store.dispatch(`misc/${MISC_INIT_DATA}`),
    store.dispatch(`misc/${MISC_FETCH_BRANDS}`).catch(noop),
  ]);
};

export const bootstrapApp = ({ force = false } = {}) => {
  if (current && !force) {
    return current;
  }

  const promise: Promise<void> = loadCritical()
    .catch((error) => {
      if (current === promise) {
        current = null;
      }
      throw error;
    });

  current = promise;
  return promise;
};
